export const workspace = {
  routes: [
    {
      path: "/workspace/library/purpose",
      component: () => import("../workspace-library-purpose-view"),
    },
    {
      path: "/workspace/library/legal-reason",
      component: () => import("../workspace-library-legal-reason-view"),
    },
    {
      path: "/workspace/library/legitimate-interest",
      component: () => import("../workspace-library-legitimate-interest-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/purpose",
      component: () => import("../management-library-purpose-view"),
    },
    {
      path: "/management/legal-reason",
      component: () => import("../management-library-legal-reason-view"),
    },
    {
      path: "/management/legitimate-interest",
      component: () => import("../management-library-legitimate-interest-view"),
    },
  ],
};
